import { Box } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState, useEffect } from 'react';
import { getRazorPayEntPlanSubscription } from 'wisestep-api';

import { Loader } from '../../auth/components/OtpPageLayout';
import { useCustomPlanStore } from '../store/customPlanStore';
import { IPaymentInfo } from '../types/IPaymentInfo';
import { IRazorpayEntPlanSub } from '../types/IRazorpayEntPlanSub';

import RazorPayPaymentCalculation from './RazorPayPaymentCalculation';

const RazorpayPlanValidator = ({ plan }: { plan: IPaymentInfo }) => {
  const enableRazorPayEntBuyBtn = useCustomPlanStore((state) => state.enableRazorPayEntBuyBtn);
  const setEnableRazorPayEntPlan = useCustomPlanStore((state) => state.setEnableRazorPayEntPlan);
  const [validated, setValidated] = useState(false);
  const [entPlanData, setEntPlanData] = useState<IRazorpayEntPlanSub | null>(null);

  useEffect(() => {
    (async () => {
      if (plan.plan === 'Enterprise') {
        setEnableRazorPayEntPlan(true);
        try {
          if (enableRazorPayEntBuyBtn && isEmpty(entPlanData)) {
            const res = await getRazorPayEntPlanSubscription();
            setEntPlanData(res.data);
            plan.time = res.data.interval;
          }
          setValidated(true);
        } catch (e) {
          console.log(e);
          setValidated(true);
        }
      } else {
        setValidated(true);
      }
    })();
  }, [enableRazorPayEntBuyBtn, entPlanData, plan, setEnableRazorPayEntPlan]);

  return (
    <>
      {validated ? (
        <RazorPayPaymentCalculation plan={plan} entPlanData={entPlanData} />
      ) : (
        <Box sx={{ height: '400px' }}>
          <Loader />
        </Box>
      )}
    </>
  );
};

export default RazorpayPlanValidator;
